import React, { memo } from "react";
import { Switch } from "antd";
import type { SwitchProps } from "antd";
import { twMerge } from "tailwind-merge";

import "./CustomSharedSwitch.css";

interface CustomSwitchProps extends SwitchProps {
  className?: string;

  checkedBg?: string;
  uncheckedBg?: string;
  disabledBg?: string;
  handleBg?: string;
  hoverBg?: string;

  style?: React.CSSProperties;
}

const CustomSwitch: React.FC<CustomSwitchProps> = ({
  className,
  size = "default",

  checkedBg,
  uncheckedBg,
  disabledBg,
  handleBg,
  hoverBg,

  style,

  ...rest
}) => {
  const mergedClassName = twMerge("custom-switch", className);

  const cssVariableStyle: React.CSSProperties = {
    ...(checkedBg
      ? {
          ["--custom-switch-checked-bg" as string]: checkedBg,
        }
      : {}),

    ...(uncheckedBg
      ? {
          ["--custom-switch-unchecked-bg" as string]: uncheckedBg,
        }
      : {}),

    ...(disabledBg
      ? {
          ["--custom-switch-disabled-bg" as string]: disabledBg,
        }
      : {}),

    ...(handleBg
      ? {
          ["--custom-switch-handle-bg" as string]: handleBg,
        }
      : {}),

    ...(hoverBg
      ? {
          ["--custom-switch-hover-bg" as string]: hoverBg,
        }
      : {}),
  };

  const mergedStyle: React.CSSProperties = style
    ? {
        ...cssVariableStyle,
        ...style,
      }
    : cssVariableStyle;

  return (
    <Switch
      {...rest}
      size={size}
      className={mergedClassName}
      style={mergedStyle}
    />
  );
};

export default memo(CustomSwitch);
